import '../assets/styles/App.css';
import React, { useState, useEffect } from 'react';

function AppPage({}) {
    return (
        <div className='App'>
            <div>
                <div
                    style={{
                        fontSize: '24px',
                        fontFamily: 'DotGothic16-Regular',
                        margin: '20px 0',
                    }}
                >
                    Random Diversity
                </div>

                <div
                    style={{
                        fontSize: '16px',
                        fontFamily: 'Pretendard-Medium',
                    }}
                >
                    디스크리트 레이블의 전시 관람을 위해 필요한 어플입니다.
                    <br />
                    '랜덤 다이버시티: 더 무비', '랜덤 다이버시티: 프래그넌스' 등
                    앞으로의 전시 관람과 참여를 위해 설치해주세요.
                    <br />
                    'RANDOM DIVERSITY' 어플리케이션을 통해, 순간의 감정을 새로운
                    방식으로 아카이빙할 수 있습니다. 일년 중 가장 행복했던
                    순간이나 소중한 사람에 대한 기억을 매년 개최되는 '랜덤
                    다이버시티' 전시에서 '이모션 백신'을 추출하고 저장하여,
                    나만의 감정 아카이브를 기록해 나가세요. 이 기록들은 일종의
                    감정 은행이자, 타임머신이 되어 나의 행복했던 기억들을
                    회상하도록 도와줍니다.
                    <br />
                    앞으로 진행되는 랜덤 다이버시티의 전시 시리즈에 대한 정보와
                    나의 감정 데이터를 기반으로 제작할 수 있는 다양한 작품들을
                    소개해드릴 예정입니다.
                    <br />
                </div>
                <div style={{ width: '100%', margin: '20px 0' }}>
                    <img
                        style={{ width: '100%' }}
                        src={require('../assets/images/app-screenshot.png')}
                    />
                </div>
                <div className='qr-codes' style={{ margin: '20px 0 50px 0' }}>
                    <div className='android-qr'>
                        <div
                            style={{
                                fontSize: '16px',
                                fontFamily: 'Pretendard-Medium',
                                marginBottom: '10px',
                            }}
                        >
                            안드로이드 다운로드
                        </div>

                        <div>
                            <img
                                style={{ width: '80%' }}
                                src={require(`../assets/images/android-qr.png`)}
                            />
                        </div>
                    </div>
                    <div className='ios-qr'>
                        <div
                            style={{
                                fontSize: '16px',
                                fontFamily: 'Pretendard-Medium',
                                marginBottom: '10px',
                            }}
                        >
                            iOS 다운로드
                        </div>

                        <div>
                            <img
                                style={{ width: '80%' }}
                                src={require(`../assets/images/ios-qr.png`)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AppPage;
